export default __webpack_public_path__ + "static/media/event-prop-1.faffe14b.png";